import { Node, NodeType } from "@/@types/chatbots";
import { VarItem, VarItemSimple } from "@/@types/manageVars";
import { nextTick } from "vue";

const findNode = (tree: Node, nodeId: number): Promise<Node | undefined> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // aqui retorna el nodo padre
      if (tree.id === nodeId) {
        return resolve(tree);
      } else if (tree.child) {
        let result = null;

        tree.child.forEach(async (item) => {
          result = await findNode(item, nodeId);
          if (result) return resolve(result);
          else return resolve(undefined);
        });
      } else {
        return resolve(undefined);
      }
    }, 0);
  });
};

/**
 * Asigna las variables que han sido usadas en los nodos padres en una constante
 * para poder usuarlas para las menciones en un texto
 * @param {String} parentNodeId - id del nodo conector de nodos
 * @param {Object[]} tree - los nodos que están siendo consultados
 * @param {String[]} simpleVars - aquí se adjuntarán todas las variables
 * @returns
 */
const assignVars = async (parentNodeId: number, tree: Node, simpleVars: VarItem[]) => {
  const parentNode = await findNode(tree, parentNodeId);
  if (!parentNode) return simpleVars;

  if (parentNode.variable) {
    console.log('parentNode.variable: ', parentNode.variable)
    simpleVars.push(parentNode.variable);
  }

  if (parentNode.api_output_variable) {
    console.log('parentNode.api_output_variable: ', parentNode.api_output_variable)
    simpleVars.push({
      id: parentNode.variable?.id,
      variable: parentNode.api_output_variable,
      name: "",
      chatbots: [],
      created_at: "",
      exclude_words: []
    });
  }

  if (parentNode.node) {
    await assignVars(parentNode.node, tree, simpleVars);
  }
};

/**
 * Filtra las variables que han sido capturadas en los nodos padres
 * @param {String} parentNodeId - id del nodo padre
 * @param {Array} tree - nodos del chatbot
 */
const filterVarsOfParents = async (parentNodeId: number, parentNodeType: NodeType, tree: Node) => {
  try {
    if (!parentNodeId) return [];
    const simpleVarsFiltered: VarItem[] = [];

    const skipParent = parentNodeType === NodeType.Options || parentNodeType === NodeType.Buttons;

    const skipGrandParent =
      parentNodeType === NodeType.Buttons ||
      parentNodeType === NodeType.CardSection ||
      parentNodeType === NodeType.ListSection;

    if (skipParent) {
      const parent = await findNode(tree, parentNodeId);
      if (!parent) return [];
      await assignVars(parent.node, tree, simpleVarsFiltered);
    } else if (skipGrandParent) {
      const parent = await findNode(tree, parentNodeId);
      if (!parent) return [];
      const grandParent = await findNode(tree, parentNodeId);
      if (!grandParent) return [];
      await assignVars(grandParent.node, tree, simpleVarsFiltered);
    } else {
      await assignVars(parentNodeId, tree, simpleVarsFiltered);
    }

    const dataVarsFiltered = simpleVarsFiltered
      ? simpleVarsFiltered.filter((simpleVar) => simpleVar !== undefined)
      : [];

    const dataVarsFormatted: VarItemSimple[] = dataVarsFiltered.map((item) => {
      console.log('item: ', item);
      const newObject = <VarItemSimple>{};
      newObject.name = item.variable ? item.variable.name : "";
      newObject.id_in_node = item.id;
      newObject.id = item.variable ? item.variable.id : 0;
      return newObject;
    });
    return dataVarsFormatted;
  } catch (err) {
    console.error(err);
  }
};

/**
 * Ejecuta una acción en todos los nodos hacia abajo a partir del nodo actual
 * @param nodeId
 */
const executeActionOnNodesBellow = (tree: Node, callback: (node: Node) => void) => {
  console.log("executeActionOnNodesBellow");
  const currentNode = tree;
  console.log("executeActionOnNodesBellow", currentNode);
  if (!currentNode) return;
  callback(currentNode);
  if (currentNode.child && currentNode.child.length > 0)
    currentNode.child.forEach((item) => {
      console.log("for item");
      executeActionOnNodesBellow(item, callback);
    });
  else return;
};

export { filterVarsOfParents, executeActionOnNodesBellow };
